class ASProductSpecifications extends HTMLElement {
  connectedCallback() {
    if (this.dataset.initialized === 'true') return;
    this.dataset.initialized = 'true';

    this.variants = JSON.parse(this.querySelector('[data-as-spec-variants]')?.textContent || '[]');
    this.necklaceVariants = JSON.parse(this.querySelector('[data-as-necklace-variants]')?.textContent || '{}');
    this.handleProductSelect = this.handleProductSelect.bind(this);

    document.addEventListener('shopify:product:select', this.handleProductSelect);
    this.handlePickerChange = () => this.syncFromCurrentPicker();
    document.addEventListener('change', this.handlePickerChange);

    // Sync the table to the currently selected options on initial load.
    window.setTimeout(() => this.syncFromCurrentPicker(), 0);
  }

  disconnectedCallback() {
    document.removeEventListener('shopify:product:select', this.handleProductSelect);
    document.removeEventListener('change', this.handlePickerChange);
  }

  handleProductSelect(event) {
    const selectedOptions = event?.selectedOptions;
    if (!Array.isArray(selectedOptions) || !selectedOptions.length) return;

    this.syncFromSelectedOptions(selectedOptions);
  }

  syncFromCurrentPicker() {
    const picker = document.querySelector('variant-picker[data-product-handle="sammy-lab-grown-diamond-ring"]') || document.querySelector('product-information variant-picker');
    if (!picker) return;

    const selectedOptions = [];

    picker.querySelectorAll('fieldset').forEach((fieldset) => {
      const checked = fieldset.querySelector('input:checked');
      if (checked?.dataset?.optionName) {
        selectedOptions.push({ name: checked.dataset.optionName, value: checked.value });
      }
    });

    picker.querySelectorAll('select').forEach((select) => {
      const option = select.selectedOptions?.[0];
      if (!option) return;
      const name = option.dataset.optionName || select.name?.replace(/^options\[|\]$/g, '');
      if (name) selectedOptions.push({ name, value: option.value });
    });

    if (selectedOptions.length) this.syncFromSelectedOptions(selectedOptions);
  }

  syncFromSelectedOptions(selectedOptions) {
    const byName = Object.fromEntries(
      selectedOptions.map((option) => [String(option.name || '').trim(), String(option.value || '').trim()])
    );

    const values = selectedOptions.map((option) => String(option.value || '').trim());
    const earringSelection = Object.entries(this.necklaceVariants).find(([, item]) =>
      Array.isArray(item.selectedOptions) &&
      item.selectedOptions.length === selectedOptions.length &&
      item.selectedOptions.every((option) => byName[option.name] === option.value)
    );
    const variant = earringSelection
      ? { sku: earringSelection[0] }
      : this.variants.find(
          (item) => Array.isArray(item.options) && item.options.every((option, index) => option === values[index])
        );

    const necklace = variant?.sku && this.necklaceVariants[variant.sku];
    if (necklace) {
      this.querySelectorAll('[data-as-necklace-description]').forEach((paragraph) => {
        paragraph.textContent = necklace.description?.[paragraph.dataset.asNecklaceDescription] ?? '';
      });
      const necklaceInitial = this.querySelector('[data-as-necklace-initial]');
      if (necklaceInitial) necklaceInitial.textContent = necklace.initial ?? '';
      const necklaceMetal = this.querySelector('[data-as-necklace-metal]');
      if (necklaceMetal) necklaceMetal.textContent = necklace.metal;
      this.querySelectorAll('[data-as-necklace-spec]').forEach((cell) => {
        const value = necklace.specifications?.[cell.dataset.asNecklaceSpec] ?? '';
        cell.textContent = value;
        cell.parentElement.hidden = value === '';
      });
    }

    const metalType = byName['Metal Types'] || byName['Metal'] || '';
    const metalColor = byName['Color'] || '';
    const centerStone = byName['Center Stone'] || '';

    let metalText = metalType;
    if (metalType && !/platinum/i.test(metalType) && metalColor) {
      metalText = `${metalType} ${metalColor} Gold`;
    }

    let caratText = '';
    const caratMatch = centerStone.match(/^(\d+(?:\.\d+)?)\s*CT/i);
    if (caratMatch) caratText = `${caratMatch[1]}ct`;

    const metalCell = this.querySelector('[data-as-spec-metal]');
    const centerStoneCell = this.querySelector('[data-as-spec-center-stone]');
    const caratCell = this.querySelector('[data-as-spec-carat]');
    const metalColorCell = this.querySelector('[data-as-spec-metal-color]');
    if (metalColorCell) {
      metalText = /platinum/i.test(metalType) ? 'Platinum' : metalType + ' Gold';
      metalColorCell.textContent = /platinum/i.test(metalType) ? 'White' : metalColor + ' Gold';
    }
    const shapeCell = this.querySelector('[data-as-spec-shape]');
    if (shapeCell) {
      shapeCell.textContent = /radiant/i.test(centerStone) ? 'Radiant' : 'Oval';
      caratText = caratMatch ? `${caratMatch[1]} ct` : caratText;
    }
    const skuCell = this.querySelector('[data-as-spec-sku]');

    if (metalCell && metalText) metalCell.textContent = metalText;
    if (centerStoneCell && centerStone) centerStoneCell.textContent = centerStone;
    if (caratCell && caratText) caratCell.textContent = caratText;
    if (skuCell && variant?.sku) skuCell.textContent = variant.sku;
  }
}

if (!customElements.get('as-product-specifications')) {
  customElements.define('as-product-specifications', ASProductSpecifications);
}

